import { useState } from "react";

export default function useSondertageDialogs() {
  // ✅ open flags
  const [createSonderEventOpen, setCreateSonderEventOpen] = useState(false);
  const [createSondertagOpen, setCreateSondertagOpen] = useState(false);
  const [createJobOpen, setCreateJobOpen] = useState(false);
  const [lockDialogOpen, setLockDialogOpen] = useState(false);

  // ✅ editing state
  const [editingSonderEvent, setEditingSonderEvent] = useState(null);
  const [editingSondertag, setEditingSondertag] = useState(null);
  const [editingJob, setEditingJob] = useState(null);

  const closeCreateSonderEvent = () => {
    setCreateSonderEventOpen(false);
    setEditingSonderEvent(null);
  };

  return {
    // ✅ open flags
    createSonderEventOpen,
    createSondertagOpen,
    createJobOpen,
    lockDialogOpen,

    // ✅ setters
    setCreateSonderEventOpen,
    setCreateSondertagOpen,
    setCreateJobOpen,
    setLockDialogOpen,

    // ✅ editing objects
    editingSonderEvent,
    editingSondertag,
    editingJob,

    setEditingSonderEvent,
    setEditingSondertag,
    setEditingJob,

    closeCreateSonderEvent,
  };
}
